import React from 'react'

import './index.scss'

export const MenuIcon: React.FC = () => (
  <svg
    className="icon icon--menu"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="stroke"
      d="M4.66667 10H15.3333M4.66667 6H15.3333M4.66667 14H15.3333"
      strokeLinecap="square"
    />
  </svg>
)
